var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0645 17.2785C15.8054 17.1159 16.3333 16.4595 16.3333 15.7009V15.3333C16.3333 14.4493 15.9821 13.6014 15.357 12.9763C14.7319 12.3512 13.8841 12 13 12H6.33333C5.44928 12 4.60143 12.3512 3.97631 12.9763C3.35119 13.6014 3 14.4493 3 15.3333V15.7723",
    fill: "#322267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12V11V12ZM6.33333 12V11V12ZM3 15.3333H2H3ZM15.0645 17.2785L14.85 16.3018L15.0645 17.2785ZM17.3333 15.7009V15.3333H15.3333V15.7009H17.3333ZM17.3333 15.3333C17.3333 14.1841 16.8768 13.0819 16.0641 12.2692L14.6499 13.6834C15.0875 14.121 15.3333 14.7145 15.3333 15.3333H17.3333ZM16.0641 12.2692C15.2515 11.4565 14.1493 11 13 11V13C13.6188 13 14.2123 13.2458 14.6499 13.6834L16.0641 12.2692ZM13 11H6.33333V13H13V11ZM6.33333 11C5.18406 11 4.08186 11.4565 3.2692 12.2692L4.68342 13.6834C5.121 13.2458 5.7145 13 6.33333 13V11ZM3.2692 12.2692C2.45655 13.0819 2 14.1841 2 15.3333H4C4 14.7145 4.24583 14.121 4.68342 13.6834L3.2692 12.2692ZM2 15.3333V15.7723H4V15.3333H2ZM15.031 18.3097L15.2789 18.2553L14.85 16.3018L14.6022 16.3562L15.031 18.3097ZM3.97137 18.2504C7.60795 19.0897 11.3856 19.1099 15.031 18.3097L14.6022 16.3562C11.2464 17.0928 7.7688 17.0742 4.42109 16.3017L3.97137 18.2504ZM2 15.7723C2 16.9566 2.81742 17.9841 3.97137 18.2504L4.42109 16.3017C4.1746 16.2448 4 16.0253 4 15.7723H2ZM15.3333 15.7009C15.3333 15.9898 15.1323 16.2398 14.85 16.3018L15.2789 18.2553C16.4786 17.9919 17.3333 16.9292 17.3333 15.7009H15.3333Z",
    fill: "#322267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 8.66667C11.5083 8.66667 13.0007 7.17428 13.0007 5.33333C13.0007 3.49238 11.5083 2 9.66732 2C7.82637 2 6.33398 3.49238 6.33398 5.33333C6.33398 7.17428 7.82637 8.66667 9.66732 8.66667Z",
    fill: "#322267",
    stroke: "#322267",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 9,
    height: 3,
    fill: "#322267"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a5d51681a5aeb261823dca26c4ea83ec.svg";
export { ForwardRef as ReactComponent };